import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchFaqs, sendMessage } from "../services/api";
import Swal from "sweetalert2";
import Chat from "../components/Chat";

const Faq = () => {
  const [formData, setFormData] = useState({
    name: "",
    emailAddress: "",
    subject: "",
    phoneNumber: "",
    message: "",
  });
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formSending, setFormSending] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSending(true);
    try {
      const response = await sendMessage(formData);
      if (response.success === true) {
        Swal.fire({
          icon: "success",
          title: "Message Sent!",
          text: "We will get back to you shortly.",
        });
        setFormData({
          name: "",
          emailAddress: "",
          subject: "",
          phoneNumber: "",
          message: "",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.message || "Something went wrong. Please try again.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Could not send message.",
      });
    } finally {
      setFormSending(false);
    }
  };

  useEffect(() => {
    const loadFaqs = async () => {
      try {
        const data = await fetchFaqs();
        // Handle different possible API response shapes
        if (data && data.success && Array.isArray(data.payload)) {
          setFaqs(data.payload);
        } else if (Array.isArray(data)) {
          setFaqs(data);
        } else if (data && data.payload && Array.isArray(data.payload.page)) {
          setFaqs(data.payload.page);
        } else {
          setFaqs([]);
        }
      } catch (err) {
        // If API fails, silently show empty state – no error message
        setFaqs([]);
      } finally {
        setLoading(false);
      }
    };
    loadFaqs();
  }, []);

  // Accordion toggle
  const handleAccordionClick = (e) => {
    const button = e.currentTarget;
    const wrapper = button.nextElementSibling;
    if (!wrapper) return;
    const isOpen = wrapper.classList.contains('open');

    // Close all others
    document.querySelectorAll('.faq-answer-wrapper.open').forEach(el => {
      if (el !== wrapper) {
        el.classList.remove('open');
        el.previousElementSibling.setAttribute('aria-expanded', 'false');
      }
    });

    if (!isOpen) {
      wrapper.classList.add('open');
      button.setAttribute('aria-expanded', 'true');
    } else {
      wrapper.classList.remove('open');
      button.setAttribute('aria-expanded', 'false');
    }
  };

  return (
    <>
      <style>{`
        .faq-page {
          background: #f9f9f9;
        }
        .faq-contact-section {
          background: #fff;
          padding: 3rem 1rem;
          box-shadow: 0 8px 24px rgba(0,0,0,0.04);
          border-radius: 16px;
          margin-bottom: 2.5rem;
        }
        .faq-contact-section h2 {
          font-size: 2rem;
          font-weight: 700;
          color: #0a1a3d;
          text-align: center;
          margin-bottom: 0.5rem;
        }
        .faq-contact-section p {
          text-align: center;
          color: #666;
          margin-bottom: 2rem;
        }
        .form-group {
          position: relative;
          margin-bottom: 1.2rem;
        }
        .form-group i {
          position: absolute;
          top: 50%;
          left: 15px;
          transform: translateY(-50%);
          color: #aaa;
        }
        .form-control {
          width: 100%;
          padding: 12px 20px 12px 40px;
          border: 1px solid #e0e0e0;
          border-radius: 10px;
          font-size: 0.95rem;
          background: #fafafa;
          transition: border 0.3s, box-shadow 0.3s;
        }
        .form-control:focus {
          border-color: #e86b24;
          box-shadow: 0 0 0 3px rgba(232,107,36,0.1);
          outline: none;
        }
        textarea.form-control {
          padding-left: 40px;
          min-height: 120px;
          resize: vertical;
        }
        .th-btn {
          background: linear-gradient(135deg, #e86b24, #d2551a);
          color: #fff;
          border: none;
          padding: 12px 24px;
          border-radius: 50px;
          font-weight: 600;
          transition: background 0.3s, transform 0.2s;
          width: 100%;
          font-size: 1rem;
          cursor: pointer;
        }
        .th-btn:hover {
          background: linear-gradient(135deg, #d2551a, #b8430e);
          transform: translateY(-2px);
        }
        .th-btn:disabled {
          opacity: 0.7;
          transform: none;
        }

        /* FAQ Accordion – new design */
        .faq-container {
          background: #fff;
          border-radius: 16px;
          padding: 30px;
          box-shadow: 0 8px 24px rgba(0,0,0,0.04);
          margin: 3rem 0;
        }
        .faq-item {
          border: 1px solid #eee;
          border-radius: 14px;
          margin-bottom: 1rem;
          overflow: hidden;
          transition: box-shadow 0.3s;
        }
        .faq-item:hover {
          box-shadow: 0 4px 15px rgba(0,0,0,0.06);
        }
        .faq-question {
          background: #fafafa;
          border: none;
          width: 100%;
          text-align: left;
          padding: 20px 25px;
          font-size: 1.05rem;
          font-weight: 600;
          color: #0a1a3d;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          transition: background 0.3s, color 0.3s;
        }
        .faq-question:hover {
          background: #f0f0f0;
          color: #e86b24;
        }
        .faq-question[aria-expanded="true"] {
          background: #e86b24;
          color: #fff;
        }
        .faq-question .accordion-icon {
          font-size: 1.4rem;
          transition: transform 0.3s;
          flex-shrink: 0;
        }
        .faq-question[aria-expanded="true"] .accordion-icon {
          transform: rotate(45deg);
        }
        .faq-answer-wrapper {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.4s ease;
        }
        .faq-answer-wrapper.open {
          max-height: 500px;
        }
        .faq-answer {
          padding: 20px 25px;
          color: #555;
          line-height: 1.7;
          font-size: 0.95rem;
          background: #fff;
          border-top: 1px solid #eee;
        }
      `}</style>

      <div className="breadcumb-wrapper" style={{ backgroundImage: "url('/assets/img/main/m1.jpeg')", backgroundSize: "cover", backgroundPosition: "center" }}>
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">FAQs</h1>
            <ul className="breadcumb-menu">
              <li><Link to="/">Home</Link></li>
              <li>FAQs</li>
            </ul>
          </div>
        </div>
      </div>

      <Chat />

      <div className="container py-5 faq-page">
        {/* Contact Form */}
        <div className="faq-contact-section">
          <h2>Need to Make an Inquiry?</h2>
          <p>Fill out the form and we'll get back to you promptly.</p>
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <i className="fal fa-user" />
                  <input type="text" className="form-control" name="name" value={formData.name} onChange={handleChange} placeholder="Full Name*" required />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <i className="fal fa-envelope" />
                  <input type="email" className="form-control" name="emailAddress" value={formData.emailAddress} onChange={handleChange} placeholder="Email Address*" required />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <i className="fal fa-phone" />
                  <input type="tel" className="form-control" name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} placeholder="Phone Number*" required />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <i className="fal fa-tag" />
                  <select name="subject" className="form-control" value={formData.subject} onChange={handleChange} required>
                    <option value="" disabled hidden>Select Subject*</option>
                    <option value="Residential Properties">Residential Properties</option>
                    <option value="Commercial Properties">Commercial Properties</option>
                    <option value="Heavy Engineering">Heavy Engineering</option>
                    <option value="General Inquiry">General Inquiry</option>
                  </select>
                </div>
              </div>
              <div className="col-12">
                <div className="form-group">
                  <i className="fal fa-pen" style={{ top: '25px' }} />
                  <textarea name="message" className="form-control" value={formData.message} onChange={handleChange} placeholder="Your Message*" required></textarea>
                </div>
              </div>
              <div className="col-12">
                <button type="submit" className="th-btn" disabled={formSending}>
                  {formSending ? "Sending..." : "Send Message"} <i className="fas fa-arrow-right ms-2"></i>
                </button>
              </div>
            </div>
          </form>
        </div>

        {/* FAQ Accordion */}
        <div className="faq-container">
          <h2 style={{ fontSize: '2rem', fontWeight: 700, color: '#0a1a3d', marginBottom: '1.5rem' }}>
            Frequently Asked Questions
          </h2>
          {loading ? (
            <p className="text-center">Loading FAQs...</p>
          ) : faqs.length > 0 ? (
            faqs.map((faq) => (
              <div className="faq-item" key={faq.id}>
                <button
                  className="faq-question"
                  onClick={handleAccordionClick}
                  aria-expanded="false"
                >
                  {faq.title || faq.question}
                  <span className="accordion-icon">+</span>
                </button>
                <div className="faq-answer-wrapper">
                  <div className="faq-answer">
                    <p>{faq.description || faq.answer}</p>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-center">No FAQs available at this time.</p>
          )}
        </div>
      </div>
    </>
  );
};

export default Faq;